const getScoreStyle = (grade) => {
  if (grade >= 80) return { bg: "#E5FBF8", color: "#00A396" };
  if (grade >= 60) return { bg: "#F4F8F7", color: "#3A434E" };
  return { bg: "#FCEDE9", color: "#C2452D" };
};

const ReviewPageButton = ({ assignment, showReviewPage }) => {
  const finished = Boolean(assignment.finished_at);
  const scoreStyle = finished ? getScoreStyle(assignment.grade) : null;

  return (
    <div
      style={{
        display: "inline-block",
        textAlign: "center",
        fontSize: "0.85rem",
        fontWeight: 800,
        fontVariantNumeric: "tabular-nums",
        backgroundColor: finished ? scoreStyle.bg : "#F4F8F7",
        color: finished ? scoreStyle.color : "#7A8490",
        border: "none",
        borderRadius: "999px",
        padding: "6px 14px",
        minWidth: "90px",
        cursor: "pointer",
        transition: "opacity .12s",
      }}
      onClick={() => showReviewPage(assignment)}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      {finished
        ? assignment.grade + "점"
        : assignment.progress_rate + "% 완료"}
    </div>
  );
};

export default ReviewPageButton;
